<!-- =========================================================================================
    File Name: TasksSidebar.vue
    Description: Email Application Sidebar(Filter) (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="email__email-sidebar h-full">
        <div class="m-6 clearfix">
          <h4> Projects </h4>
        </div>


        <VuePerfectScrollbar :is="scrollbarTag" class="email-filter-scroll-area" :settings="settings" :key="$vs.rtl">
            <div class="px-6 pb-2 flex flex-col">
                <ul class="centerx">
                  <div :data="project" :key="index" v-for="(project, index) in projectList" class="my-4">
                  <li>
                    <vs-radio v-model="radios" :vs-value="project.id" vs-name="radios"> 
                      <div><h6>{{project.name}}</h6></div> 
                      <div v-if="project.projectCategory != null">{{project.projectCategory.name}}</div> 
                      <div v-else>Jira Category Unset!</div>
                    </vs-radio>
                  </li>
                  </div>
                </ul>
            </div>
        </VuePerfectScrollbar>
    </div>
</template>

<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  data () {
    return {
      radios:-1,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30
      }
    }
  },
  watch: {
    radios (radio) {
      this.SetSelectedProjectID()
      
    }
  },
  computed: {
    // taskList () {
    //   return this.$store.getters.GetMyTaskList
    // },
    fullProjectList () {
      return this.$store.getters.GetProjectList
    },
    projectList () {
      const projects = []
      const projectIDS = []
      this.taskList.forEach(task => {
        if (projectIDS.indexOf(task.fields.project.id) == -1) {
          projectIDS.push(task.fields.project.id)
          projects.push(task.fields.project)
        }
      })
      return projects
    },
    clientList () {
      return this.$store.getters.GetClientList
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    clientNameFromID (id) {
      for (let i = 0; i < this.clientList.length; i++) {
        if (this.clientList[i].ClientID == id) {
          return this.clientList[i].ClientName
        }
      }
    },
    GetFullProject (id) {
      return this.fullProjectList.find(x => x.id == id)
    },
    SetSelectedProjectID () {
      const proj = this.projectList.find(x => x.id == this.radios)
      if (proj == null) return null


      this.$store.commit('SetSelectedProjectID', proj.id)
    }
  },
  components: {
    VuePerfectScrollbar
  },
  mounted () {
    //this.SetSelectedProjectID()
  }
}

</script>

